export const columns = [
  {
    title: '患者ID',
    dataIndex: 'ucPatientId',
    width: 100
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    width: 100,
    slots: { customRender: 'patientName' }
  },
  {
    title: '昵称',
    dataIndex: 'nickName',
    width: 120
  },
  {
    title: '患者手机号码',
    dataIndex: 'patientPhone',
    width: 150,
    slots: { customRender: 'patientPhone' }
  },
  {
    title: '主动触达时间',
    dataIndex: 'activeReachTime',
    width: 220,
    slots: { customRender: 'activeReachTime' },
    sorter: true
  },
  {
    title: '上次触达时间',
    dataIndex: 'lastActiveTouchAt',
    width: 280,
    slots: { customRender: 'lastActiveTouchAt' },
    sorter: true
  },
  {
    title: '主动回访状态',
    dataIndex: 'activeFollowupStatusName',
    width: 200,
    slots: { customRender: 'activeFollowupStatusName' }
  },
  {
    title: '绑定医生人数',
    dataIndex: 'boundDoctorNum',
    width: 140,
    slots: { customRender: 'boundDoctorNum' },
    sorter: true
  },
  {
    title: '注册时间',
    dataIndex: 'createAt',
    width: 180,
    sorter: true
  },
  {
    title: '认证状态',
    dataIndex: 'statusStr',
    width: 100,
    slots: { customRender: 'statusStr' }
  },
  {
    title: '关注状态',
    dataIndex: 'cancelStr',
    width: 100,
    slots: { customRender: 'cancelStr' }
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 180,
    align: 'center',
    fixed: 'right',
    slots: { customRender: 'operate' }
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
// 认证状态
export const patientStatusMap = [
  {
    value: 0,
    label: '未认证',
    color: {
      color: '#FF4D4F',
      bg: '#FFF1F0',
      bc: '#FFCCC7'
    }
  },
  {
    value: 1,
    label: '已认证',
    color: {
      color: '#1FB5AB',
      bg: '#1fb5ab1a',
      bc: '#1fb5ab4d'
    }
  }
]
// 关注状态
export const followStatusMap = [
  {
    value: 0,
    label: '未知',
    color: '#00000033'
  },
  {
    value: 1,
    label: '未取消',
    color: '#1FB5AB'
  },
  {
    value: 2,
    label: '已取消',
    color: '#FF4D4F'
  }
]
// 处方状态
export const prescriptionStatusMap = [
  {
    value: 0,
    label: '未购买'
  },
  {
    value: 1,
    label: '已购买'
  },
  {
    value: 2,
    label: '已售后'
  },
  {
    value: 3,
    label: '已失效'
  }
]
// 购买频次
export const recomBuyCntMap = [
  {
    value: 0,
    label: 0
  },
  {
    value: 1,
    label: 1
  },
  {
    value: 2,
    label: 2
  },
  {
    value: 3,
    label: '3次及以上'
  }
]
// 开具药品（废弃：静态字典；远程搜索接口 searchDrugOptions 上线后可删除）
export const skuNameMap = [
  {
    value: '复方玄驹胶囊',
    label: '复方玄驹胶囊'
  },
  {
    value: '山海丹颗粒',
    label: '山海丹颗粒'
  },
  {
    value: '金石淋 枸橼酸氢钾钠',
    label: '金石淋 枸橼酸氢钾钠'
  },
  {
    value: '舒驰 硫酸氨基葡萄糖',
    label: '舒驰 硫酸氨基葡萄糖'
  },
  {
    value: '施威尔 盐酸伐地那非片',
    label: '施威尔 盐酸伐地那非片'
  },
  {
    value: '施朗生 枸橼酸托法替布片',
    label: '施朗生 枸橼酸托法替布片'
  },
  {
    value: '元恩',
    label: '元恩'
  },
  {
    value: '减压宁神方',
    label: '减压宁神方'
  },
  {
    value: '痛风方',
    label: '痛风方'
  },
  {
    value: '壮阳固精方',
    label: '壮阳固精方'
  },
  {
    value: '前列解通方',
    label: '前列解通方'
  },
  {
    value: '助育生精方',
    label: '助育生精方'
  },
  {
    value: '降尿酸治痛风方',
    label: '降尿酸治痛风方'
  },
  {
    value: '舍曲林',
    label: '舍曲林'
  },
  {
    value: '西酞普兰',
    label: '西酞普兰'
  },
  {
    value: '美利曲辛片',
    label: '美利曲辛片'
  },
  {
    value: '盐酸氟西汀胶囊',
    label: '盐酸氟西汀胶囊'
  },
  {
    value: '帕罗西汀',
    label: '帕罗西汀'
  },
  {
    value: '喹硫平',
    label: '喹硫平'
  },
  {
    value: '奥氮平',
    label: '奥氮平'
  },
  {
    value: '安非他酮',
    label: '安非他酮'
  }
]
// 回访次数
export const activeFollowupCntMap = [
  {
    value: 1,
    label: '1次'
  },
  {
    value: 2,
    label: '2次'
  },
  {
    value: 3,
    label: '3次'
  },
  {
    value: 4,
    label: '4次及以上'
  }
]
// 主动回访状态
export const activeFollowupStatusMap = [
  {
    value: 0,
    label: '未在回访池'
  },
  {
    value: 1,
    label: '已在回访池'
  },
  {
    value: 3,
    label: '已设置下次回访'
  }
]
// 回访状态色块说明
export const followupLegend = [
  {
    label: '已加入回访池',
    value: 1,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      background: '#9BD4FD'
    }
  },
  {
    label: '已设置下次回访',
    value: 3,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      background: '#FDD265'
    }
  },
  {
    label: '未加入回访池',
    value: 0,
    style: {
      width: '14px',
      height: '14px',
      borderRadius: '4px',
      border: '1px solid #D8D8D8',
      background: '#FFF'
    }
  }
]
// 行背景色：已设置下次回访 > 已加入回访池 > 未加入回访池
export const ROW_FOLLOWUP_BG = {
  followupSet: '#FFF5DB', // 已设置下次回访
  inPool: '#E1F2FE', // 已加入回访池
  notInPool: '#ffffff' // 未加入回访池
}
